import { type ComponentProps, createContext, useContext } from 'react';

import type {
  NoticeBannersStackItems,
  NoticeBannersStackProvider,
} from './NoticeBannersStackProvider';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Internal to garnish and intentionally left out of the barrel: only
 * `NoticeBannersStack` renders the stack. Everything else sends banners
 * with `useNoticeBannersStackActions`, which does not re-render on stack changes.
 */
export const NoticeBannersStackContext = createContext<NoticeBannersStackContextValue | undefined>(
  undefined,
);

export const useNoticeBannersStack = () => {
  const context = useContext(NoticeBannersStackContext);

  if (context === undefined) {
    throw new Error('useNoticeBannersStack must be used within a <NoticeBannersStackProvider>');
  }

  return context;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type NoticeBannersStackContextValue = {
  stack: NoticeBannersStackItems;
  variant: NonNullable<ComponentProps<typeof NoticeBannersStackProvider>['variant']>;
  isLiquidGlassEnabled: boolean;
};
